import React from 'react'
import { HideDirtyStateContext } from './HideDirtyStateContext'

/**
 * Generic context to use to allow or restrict viewing the dirty state of form controls.
 * Used to hide the dirty state if a device is new (unsaved).
 */
export const HideDirtyStateProvider: React.FC<{
  hideDirtyState: boolean
  children: React.ReactNode
}> = ({ hideDirtyState, children }) => {
  return <HideDirtyStateContext.Provider value={hideDirtyState}>{children}</HideDirtyStateContext.Provider>
}
